module.exports = __webpack_public_path__ + "img/fashion_60.9cba1dd7.jpg";